import React from "react";
import { FiChevronLeft, FiChevronRight, FiChevronsLeft, FiChevronsRight } from "react-icons/fi";

function Pagination({ total = 1, active = 0, onChange = () => {}, className = "", showNumbers = true, showFirstLast = false }) {
	const totalPages = Math.max(1, Number(total) || 1);
	const currentPage = Math.min(Math.max(Number(active) || 1, 1), totalPages);

	const goTo = (page) => {
		if (page < 1 || page > totalPages || page === currentPage) return;
		onChange(page);
	};

	const getPageItems = () => {
		if (totalPages <= 7) {
			return Array.from({ length: totalPages }, (_, i) => i + 1);
		}

		const items = [1];
		const start = Math.max(2, currentPage - 1);
		const end = Math.min(totalPages - 1, currentPage + 1);

		if (start > 2) items.push("start-ellipsis");
		for (let i = start; i <= end; i += 1) items.push(i);
		if (end < totalPages - 1) items.push("end-ellipsis");
		items.push(totalPages);
		return items;
	};

	return (
		<nav className={`pagination ${showNumbers ? "" : "compact"} ${className}`} aria-label="Pagination">
			{showFirstLast && (
				<button type="button" onClick={() => goTo(1)} className={`page hidden sm:inline-flex ${currentPage <= 1 ? "disabled" : ""}`} aria-label="First page" title="First page">
					<FiChevronsLeft className="w-4 h-4" aria-hidden="true" />
					<span className="sr-only">First page</span>
				</button>
			)}
			<button type="button" onClick={() => goTo(currentPage - 1)} className={`page rounded-l-md ${currentPage <= 1 ? "disabled" : ""}`} aria-label="Previous page" title="Previous page">
				<FiChevronLeft className="w-4 h-4" aria-hidden="true" />
				<span className="sr-only">Previous page</span>
			</button>
			{showNumbers ? (
				getPageItems().map((item, i) =>
					typeof item === "number" ? (
						<button key={i} type="button" onClick={() => goTo(item)} className={`page ${currentPage === item ? "active" : ""}`} aria-label={`Go to page ${item}`}>
							{item}
						</button>
					) : (
						<span key={i} className="page ellipsis" aria-hidden="true">
							...
						</span>
					)
				)
			) : (
				<div className="page indicator !w-auto !px-3 cursor-default">
					Page {currentPage} of {totalPages}
				</div>
			)}
			<button type="button" onClick={() => goTo(currentPage + 1)} className={`page rounded-r-md ${currentPage >= totalPages ? "disabled" : ""}`} aria-label="Next page" title="Next page">
				<FiChevronRight className="w-4 h-4" aria-hidden="true" />
				<span className="sr-only">Next page</span>
			</button>
			{showFirstLast && (
				<button type="button" onClick={() => goTo(totalPages)} className={`page hidden sm:inline-flex ${currentPage >= totalPages ? "disabled" : ""}`} aria-label="Last page" title="Last page">
					<FiChevronsRight className="w-4 h-4" aria-hidden="true" />
					<span className="sr-only">Last page</span>
				</button>
			)}
		</nav>
	);
}

export default Pagination;
